/**
 * Rutas y textos compartidos del embudo membresía → cuenta → aprobación → acceso.
 * Mantiene coherencia entre portal, registro, pendiente y mi-acceso.
 *
 * Orden del embudo (post-pago):
 *   REGISTRO → COMPLETAR_REGISTRO → PORTAL
 * PORTAL es la página única: muestra los datos del usuario (estilo CRM), espera la
 * aprobación del equipo y, al aprobarse, muestra el link privado de ingreso (distinto
 * por membresía, configurado en admin). PENDING_APPROVAL y MI_ACCESO redirigen a PORTAL.
 * ENTRAR = sesión existente sin alta de membresía en curso.
 */

export const MEMBERSHIP_ACCESS_PORTAL_PATH = "/portal-acceso";

/** Rutas del embudo público (única fuente para Router y redirects). */
export const MEMBERSHIP_ROUTE = {
  REGISTRO: "/registro",
  COMPLETAR_REGISTRO: "/completar-registro",
  /** Página única post-pago: datos del usuario + espera + link de ingreso al aprobar. */
  PORTAL: "/portal",
  /** Legacy — redirigen a PORTAL (se mantienen por links externos y compatibilidad). */
  PENDING_APPROVAL: "/pending-approval",
  MI_ACCESO: "/mi-acceso",
  ENTRAR: "/entrar",
} as const;

export type MembershipFunnelPath = (typeof MEMBERSHIP_ROUTE)[keyof typeof MEMBERSHIP_ROUTE];

/** Texto del enlace secundario repetido en las pantallas del embudo. */
export const MEMBERSHIP_PORTAL_LINK_TEXT = "Access steps guide";

